import { Component, OnInit, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { CdsIconModule } from '@cds/ng-web-components/icon';

export type MattersNeedingAttentionType = 'yellow' | 'red';

@Component({
  selector: 'app-matters-needing-attention',
  templateUrl: './matters-needing-attention.component.html',
  styleUrls: ['./matters-needing-attention.component.scss'],
  imports: [NgClass, CdsIconModule],
})
export class MattersNeedingAttentionComponent implements OnInit {
  @Input() title!: string;
  @Input() text!: string;
  @Input() color: MattersNeedingAttentionType = 'yellow';

  constructor() {}

  ngOnInit(): void {}
}
